import { render } from "./AppLoaderV2.vue?vue&type=template&id=0ccb6cbf&scoped=true"
const script = {}

import "./AppLoaderV2.vue?vue&type=style&index=0&id=0ccb6cbf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ccb6cbf"]])

export default __exports__